var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTerraformLogo = function SvgTerraformLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5c4ee5",
    d: "M77.941 44.5v36.836L46.324 62.918V26.082zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4040b2",
    d: "m81.41 81.336 31.633-18.418V26.082L81.41 44.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c4ee5",
    d: "M11.242 42.36 42.86 60.776V23.941L11.242 5.523zm66.699 43.015L46.324 66.957v36.82l31.617 18.418zm0 0"
  }))));
};
export default SvgTerraformLogo;